import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import HealthClassCalcStackedButton from '../HealthClassCalculator/HealthClassCalcStackedButton';
import HealthClass from "./HealthClass";

export default function TermInsuranceHealthTools(props) {
  const { toolName, title, onHealthClassChange, healthClass } = props;

  const getHealthClassNameFromCode = (hcCode) => {
    const healthClassMap = HealthClass();
    const currentHealthClass = healthClassMap.find((hc) => hc.value === hcCode.toUpperCase());
    return currentHealthClass.label;
  };

  return (
    <HealthClassCalcStackedButton
      type='quote-screen'
      condensed
      toolName={toolName}
      title={title}
      currentHealthClass={getHealthClassNameFromCode(healthClass)}
      onHealthClassChange={onHealthClassChange}
    />
  );
};

TermInsuranceHealthTools.propTypes = {
  toolName: PropTypes.string,
  title: PropTypes.string,
  healthClass: PropTypes.string,
  onHealthClassChange: PropTypes.func,
};
